import { ProjectModel } from "@/models";
import { OptionItemModel } from "../components/options-filter/models";
import { GetGlobalStatusesItem } from "./GetGlobalStatusesItem";
import { TagModel } from "@/components/task-forms/models";
import { NamespaceModel } from "./NamespaceModel";
import { TypeModel } from "@/pages/namespace-types-settings-page/models";
import { DifficultyListItem } from "./DifficultyListItem";
import {
  GetDifficultyListItemDetail,
  GetStatusesListDetailItem,
  ProjectQueueTaskListItem,
} from "../adapter";

export class FilterOptions {
  /**Глобальные статусы */
  GlobalStatuses: GetGlobalStatusesItem[];
  /**Проекты */
  Projects: OptionItemModel[];
  /**Теги проекта */
  Tags: TagModel[];
  /**НС проекта */
  Namespaces: OptionItemModel[];
  /**Типы */
  Types: TypeModel[];
  /**Сложности */
  Difficultys: OptionItemModel[];
  /**Очереди */
  Queues: ProjectQueueTaskListItem[];
  /**Статусы */
  Statuses: OptionItemModel[];
  /**Приоритеты */
  Priorities: OptionItemModel[];
  /**Скрытые элементы */
  HiddenElements?: OptionItemModel[];

  constructor(obj?: Partial<FilterOptions>) {
    Object.assign(this, obj);
  }
}
